import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const Camera = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 15"
      style={style}
    >
      <g transform="matrix(1,0,0,1,-3,-4.5)">
        <path d="M14.82,4.5C15.356,4.5 15.86,4.755 16.177,5.185L16.198,5.215L16.753,6L18.75,6C19.98,6 20.98,6.982 21,8.201L21,17.262C21,18.485 20.013,19.48 18.787,19.5L5.25,19.5C4.02,19.5 3.02,18.518 3,17.299L3,8.238C3,7.015 3.987,6.02 5.213,6L7.34,6L7.895,5.214C8.205,4.776 8.703,4.512 9.238,4.5L14.82,4.5ZM14.82,5.625L9.274,5.625C9.099,5.625 8.934,5.706 8.829,5.844L8.814,5.864L7.96,7.074L7.923,7.124L5.245,7.125C4.633,7.125 4.135,7.61 4.12,8.215L4.12,17.257C4.12,17.865 4.608,18.36 5.216,18.375L18.755,18.375C19.367,18.375 19.865,17.89 19.88,17.285L19.88,8.243C19.88,7.635 19.392,7.14 18.784,7.125L16.177,7.125L16.134,7.075L15.279,5.863C15.179,5.72 15.017,5.633 14.843,5.626L14.82,5.625ZM12,8.906C13.968,8.906 15.563,10.501 15.563,12.469C15.563,14.436 13.968,16.031 12,16.031C10.032,16.031 8.437,14.436 8.437,12.469C8.437,10.501 10.032,8.906 12,8.906ZM12,10.031C10.654,10.031 9.562,11.123 9.562,12.469C9.562,13.815 10.654,14.906 12,14.906C13.346,14.906 14.438,13.815 14.438,12.469C14.438,11.123 13.346,10.031 12,10.031ZM17.719,8.156C18.289,8.156 18.75,8.618 18.75,9.187C18.75,9.757 18.288,10.219 17.719,10.219C17.149,10.219 16.687,9.757 16.687,9.188C16.687,8.618 17.149,8.156 17.719,8.156Z" />
      </g>
    </svg>
  );
};

Camera.defaultProps = {
  width: '16px',
  height: '15px',
  style: {},
};

export default Camera;
